export default `<p class=MsoNormal><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif'>&nbsp;2022-23
New York Knicks Ticket Terms and Conditions</span></p>

<p class=MsoNormal style='text-align:justify;border:none'><span
style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>This ticket is a license to an event revocable in Madison Square
Garden's (“MSG”) sole discretion, and the holder of this ticket, on behalf of
the holder and any accompanying minor, including a minor holding a separate
ticket (individually and collectively, the &quot;Holder&quot;), agrees to all
of its terms.  The Holder agrees that this ticket license is subject to these
terms and conditions, as well as any additional terms and conditions
established by MSG, the New York Knicks and/or its affiliates (the “Team”), the
National Basketball Association and/or its affiliates (the &quot;NBA&quot;),
the Madison Square Garden arena or related arena grounds (including, without
limitation, parking areas and entry gates) (the “Arena”) at which the event or
any surrounding activities (in whole or in part) for which this ticket is
issued (the “Event”) is held (collectively, all such additional terms,
“Supplemental Terms”).  By acceptance and/or use of this ticket and/or entering
(or seeking entry into) the Arena, the Holder is deemed to have read all such
terms and agreed to be bound by them.</span><span style='font-size:10.0pt;
font-family:"Arial",sans-serif;color:black'>  </span><span style='font-size:
12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>Failure to comply with
such terms or with venue rules, and/or conduct MSG deems disorderly or abusive,
may subject you to non-admission, ejection, and other available legal remedies.
MSG reserves the right, without refund of the purchase price, to refuse
admission to or eject any person for any reason. No weapons or other dangerous
items allowed; for a full list of prohibited items, please visit </span><a
href="https://www.msg.com/madison-square-garden/faqs"><span style='font-size:
12.0pt;font-family:"Lucida Sans",sans-serif;color:blue'>https://www.msg.com/madison-square-garden/faqs</span></a><u><span
style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;color:blue'>.</span></u></p>

<p class=MsoNormal><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>This ticket and the Holder's admission to the Arena are subject to
all safety and health requirements and policies relating to the novel
coronavirus SARS-CoV-2 and any resulting disease (together with any mutation,
adaptation or variation thereof, collectively “COVID-19”) put in place by MSG,
the Team, NBA, and Arena, including those policies and requirements described
in the Supplemental Terms.  Such policies and requirements as they may be
updated from time to time (in the sole determination of the Team, NBA and/or
Arena) and as they may be communicated to the Holder prior to or during the
Event (whether orally or in writing) by, for example, instruction provided by
MSG, Team or Arena personnel or signage in or around the Arena, are
collectively referred to below as the “Safety Requirements”.  The Holder
acknowledges and agrees to comply with the Safety Requirements (including all
requirements that must be satisfied prior to or during the Event), and acknowledges
and agrees that attendance at the Event is conditioned on such compliance.</span></p>

<p class=MsoNormal style='text-align:justify;border:none'><span
style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>The Holder agrees, on behalf of the Holder and Holder's Related
Persons (defined below), that the Holder and each such individual will not
attend the Event if any one or more of the following is true on the day of such
Event:</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-.25in;background:white;border:none'><span style='font-size:12.0pt;font-family:
"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-.25in;background:white;border:none'><span style='font-size:10.0pt;font-family:
"Noto Sans Symbols";color:black'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>Within the prior 10 days, any such individual has returned a
positive or inconclusive test result for COVID-19;</span></p>

<p class=MsoNormal style='text-align:justify;background:white;border:none'><span
style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-.25in;background:white;border:none'><span style='font-size:10.0pt;font-family:
"Noto Sans Symbols";color:black'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>Within the prior 5 days, any such individual was exposed to
someone who has tested positive for COVID-19 while such individual was not (i)
up-to-date on vaccination against COVID-19, as defined by the Centers for
Disease Control and Prevention (“CDC”), or (ii) recently recovered from a
confirmed prior infection of COVID-19 within the past 90 days; or</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-.25in;background:white;border:none'><span style='font-size:12.0pt;font-family:
"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:14.0pt;
text-align:justify;text-indent:-.25in;background:white;
border:none'><span style='font-size:10.0pt;font-family:"Noto Sans Symbols";
color:black'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>Any such individual is experiencing symptoms associated with
COVID-19 (e.g., sore throat, cough, nasal congestion) and has not returned a
negative test result from an FDA-authorized test collected after symptom onset
and within 1 day prior to the Event. </span></p>

<p class=MsoNormal style='margin-left:.5in;border:none'><span style='font-size:
12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>Notwithstanding the
foregoing, the individual may attend the Event if such individual has received
clearance by a healthcare provider or public health authority, or pursuant to
applicable public health guidelines, not to quarantine or isolate.</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>4.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:#333333'>Any transfer of this ticket to any person who fails to satisfy
any Safety Requirement (including pre-Event requirements established by MSG,
the Team or Arena) will not be admitted into the Arena and/or will be ejected
from the Arena.</span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'> </span></p>

<p class=MsoNormal style='text-align:justify;border:none'><span
style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>5.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>ALL TICKET SALES ARE FINAL. NO REFUNDS, CREDITS OR EXCHANGES
EXCEPT AS PROVIDED HEREIN. YOU ACKNOWLEDGE THAT YOU ARE NOT ENTITLED TO ANY
REFUND IN THE EVENT OF A RESCHEDULING OF THE EVENT</span></b><span
style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>.  <b>IN
NO EVENT SHALL THE TEAM, NBA, OR ARENA BE LIABLE FOR ANY SPECIAL,
CONSEQUENTIAL, INCIDENTAL, INDIRECT OR EXEMPLARY DAMAGES OF ANY KIND, OR ANY
DAMAGES BEYOND THE FACE VALUE OF THE TICKET, INCLUDING, WITHOUT LIMITATION, ANY
AMOUNT PAID IN EXCESS OF <span style='font-variant:small-caps'>THE TICKET'S
FACE VALUE SET BY THE TEAM</span>.</b></span></p>

<p class=MsoNormal style='margin-left:.5in;border:none'><span style='font-size:
12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;border:none'><span
style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>The
Event date and time (and gate opening) are subject to change at the sole
discretion of MSG, the Team, and the Arena, and no material change shall entitle Holder to a refund or other remedy
if the Holder cannot attend or for any other reason.  The Holder may be
relocated in the Team's sole discretion, <b>and no such relocation shall
entitle the Holder to a refund or other remedy if the Holder is relocated to a
seat or location of comparable Face Value.</b></span></p>

<p class=MsoNormal style='margin-left:.5in;border:none'><span style='font-size:
12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>6.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>The Holder agrees not to create, transmit, distribute,
misappropriate or sell (or aid in creating, transmitting, distributing,
misappropriating or selling), in any media now or hereafter existing, any
description, account (whether text, data or visual, and including (without
limitation) play-by-play data), picture, video, audio or other form of
exploitation or reproduction of the Event (collectively, “Event Works”).&nbsp;
Notwithstanding the foregoing, the Holder Agrees that by causing this ticket to
be scanned upon entry, the Holder shall be deemed to have signed the ticket and
granted to the Team and NBA an exclusive, worldwide, irrevocable, perpetual,
sub-licensable, royalty-free license to all rights associated with any Event
Works.  This ticket may not be used for any form of commercial or trade
purposes, including, but not limited to, advertising, promotions, contests,
sweepstakes, giveaways, gambling or gaming activities, without the express
written consent of the Team and NBA.</span></p>

<p class=MsoNormal style='margin-left:.5in;border:none'><span style='font-size:
12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>7.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>Breach of any of these terms, failure to comply with Safety
Requirements or NBA, Team and/or Arena rules, or the refunding to the Holder of
the Face Value, shall automatically terminate any rights that the Holder may
have hereunder; shall render illegal and unauthorized the Holder's use of the
ticket for any purpose; and shall authorize MSG, the Team and/or the NBA to
withdraw the ticket, refuse admission to the Arena, or eject the Holder from
the Arena, without refund or credit in each case, and subject the Holder to all
legal remedies available to the NBA, Team and/or Arena.</span></p>

<p class=MsoNormal style='margin-left:.5in;border:none'><span style='font-size:
12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>8.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
font-variant:small-caps;color:black'>THE HOLDER EXPRESSLY ACKNOWLEDGES A<span
style='background:white'>N INHERENT RISK OF EXPOSURE TO COVID-19 EXISTS IN ANY
PLACE WHERE PEOPLE GATHER AND THAT NO PRECAUTIONS (INCLUDING THE SAFETY
REQUIREMENTS DESCRIBED ABOVE) CAN ELIMINATE THE RISK OF EXPOSURE TO COVID-19. 
COVID-19 IS AN EXTREMELY CONTAGIOUS DISEASE THAT CAN LEAD TO SEVERE ILLNESS AND
DEATH.  </span>WHILE PEOPLE OF ALL AGES AND HEALTH CONDITIONS HAVE BEEN
ADVERSELY AFFECTED BY COVID-19, CERTAIN CATEGORIES OF PEOPLE HAVE BEEN
IDENTIFIED BY PUBLIC HEALTH AUTHORITIES AS HAVING GREATER RISK BASED ON AGE AND
UNDERLYING MEDICAL CONDITIONS</span><span style='font-size:12.0pt;font-family:
"Lucida Sans",sans-serif;color:black'>.  THE HOLDER OF THIS TICKET VOLUNTARILY
ASSUMES ALL RISK AND DANGER OF PERSONAL INJURY (INCLUDING DEATH), SICKNESS
(INCLUDING ILLNESS AND OTHER RISKS OF EXPOSURE TO COVID-19, OR ANY OTHER
COMMUNICABLE DISEASE OR ILLNESS, OR A BACTERIA, VIRUS OR OTHER PATHOGEN CAPABLE
OF CAUSING A COMMUNICABLE DISEASE OR ILLNESS), LOST, STOLEN, DAMAGED OR
CONFISCATED PROPERTY, AND ALL OTHER HAZARDS ARISING FROM, OR RELATED IN ANY WAY
TO, THE EVENT (INCLUDING COMPLYING WITH THE SAFETY REQUIREMENTS), WHETHER
OCCURRING PRIOR TO, DURING OR AFTER THE EVENT, HOWEVER CAUSED AND WHETHER BY
NEGLIGENCE OR OTHERWISE.</span></p>

<p class=MsoNormal style='margin-left:.5in;border:none'><span style='font-size:
12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>9.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>On behalf of the Holder and the Holder's Related Persons (defined
below), the Holder further hereby releases (and covenants not to sue) each of
the Released Parties (defined below) with respect to any and all claims that
the Holder or any of the Holder's Related Persons may have (or hereafter
accrue) against any of the Released Parties and that relate in any way to (i)
exposure to COVID-19 or a COVID-19 infection, whether such exposure or
infection occurs before, during, or after any Event; (ii) entry into, or
presence within or around, the Arena or the Event (including all risks related
thereto) or compliance with any protocols or Safety Requirements applicable to
the Event; or (iii) any interaction between the Holder and the Holder's Related
Persons, on the one hand, and any personnel of any of the Released Parties
present at the Event, on the other hand, in each case whether caused by any
action, inaction or negligence of any Released Party or otherwise.</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-.25in;background:white;border:none'><span style='font-size:12.0pt;font-family:
"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
4.5pt;background:white;border:none'><span style='font-size:12.0pt;font-family:
"Lucida Sans",sans-serif;color:black'>As used herein:</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-.25in;background:white;border:none'><span style='font-size:12.0pt;font-family:
"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-.25in;background:white;border:none'><span style='font-size:10.0pt;font-family:
"Noto Sans Symbols";color:black'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>“Related Persons” means the Holder's heirs, assigns, executors,
administrators, next of kin, anyone attending the Event with the Holder or for
whom Holder has obtained an Event ticket (which persons the Holder represents
have authorized the Holder to act on their behalf for purposes of these terms),
and other persons acting or purporting to act on the Holder's or their behalf.</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-.25in;background:white;border:none'><span style='font-size:12.0pt;font-family:
"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:14.0pt;
text-align:justify;text-indent:-.25in;background:white;
border:none'><span style='font-size:10.0pt;font-family:"Noto Sans Symbols";
color:black'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>“Released Parties” means: (i) the National Basketball Association
and its member teams (including the Team), and each of their respective direct
and indirect owners, affiliates, players and coaches, administrators,
designees, licensees, and other personnel; (ii) the direct and indirect owners,
lessees and sublessees of the Arena; (iii) all third parties performing
services at the Arena; (iv) any parents, subsidiaries, affiliated and related
companies of each of the entities described in clauses (i)-(iii); and (v) the
officers, directors, owners, members, managers, partners, employers, employees,
agents, contractors and sub-contractors (and employees of such contractors and
sub-contractors), insurers, representatives, other personnel, successors and/or
assigns of each of the foregoing entities and persons described in clauses (i)
- (iv), whether past, present or future and whether in their institutional or
personal capacities.</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>10.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>The Holder and the Holder's belongings may be searched upon entry
into the Arena and/or other security checkpoints, prohibited items (which may
include, without limitation, bags) may be confiscated at the sole discretion of
the NBA, Team and/or Arena, and the Holder hereby consents to the foregoing and
waives any related claims that might arise against the NBA, Team or
Arena.&nbsp; If the Holder elects not to consent, the Holder will be denied
entry into the Arena without refund or credit.</span></p>

<p class=MsoNormal style='text-align:justify;border:none'><span
style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>11.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>The Holder grants permission to the NBA and Team (and their
respective affiliates, designees and agents) to utilize the Holder's image,
likeness, actions and statements in any live or recorded audio, video, film, or
photographic display or other transmission, exhibition, publication or
reproduction made of, or at, the Event<b> </b>in any medium, whether now known
or hereafter created, or context for any purpose, including commercial or
promotional purposes, without further authorization or compensation.  In
addition, the Holder grants to the NBA and Team permission to collect, use,
share and store certain Holder facial and other biometric information as
permitted by law, including for security purposes.</span></p>

<p class=MsoNormal style='text-align:justify'><span style='font-size:12.0pt;
font-family:"Lucida Sans",sans-serif'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>12.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>Without limiting the foregoing, the Holder agrees not to give or
offer this ticket in a manner that would constitute a violation of the U.S.
Foreign Corrupt Practices Act, any other anti-bribery law or regulation, or any
conflicts of interest law, regulation, or policy.</span></p>

<p class=MsoNormal style='margin-left:.5in;border:none'><span style='font-size:
12.0pt;font-family:"Lucida Sans",sans-serif;color:black;background:white'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black'>13.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black;background:white'>If any provision or part of these terms or the
Supplemental Terms is held to be illegal, unenforceable or ineffective, such
provision or part thereof shall be deemed modified to the least extent
necessary to render such provision legal, enforceable and effective, or, if no
such modification is possible, such provision or part thereof shall be deemed
severable, such that all other provisions in and referenced in these terms and
the Supplemental Terms remain valid and binding.</span></p>

<p class=MsoNormal style='margin-left:.5in;border:none'><span style='font-size:
12.0pt;font-family:"Lucida Sans",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-indent:
-31.5pt;border:none'><span style='font-family:"Lucida Sans",sans-serif;
color:black'>14.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif;
color:black;background:white'>In the event of a conflict between Ticketmaster's
terms and these terms and conditions, these terms and conditions will apply.</span><b><span
style='font-family:"Lucida Sans",sans-serif;color:black'> </span></b></p>

<p class=MsoNormal style='margin-top:6.0pt;text-align:justify'><b><span
style='font-family:"Lucida Sans",sans-serif'>&nbsp;</span></b></p>

<p class=MsoNormal style='margin-left:27.0pt;text-align:justify'><span
style='font-family:"Lucida Sans",sans-serif'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify'><span style='font-size:12.0pt;
font-family:"Lucida Sans",sans-serif'> </span></p>

<p class=MsoNormal><span style='font-size:12.0pt;font-family:"Lucida Sans",sans-serif'>&nbsp;</span></p>

<p class=MsoNormal>&nbsp;</p>`;
